const NAME = 'metisMenu';
const DATA_KEY = 'metisMenu';
const EVENT_KEY = `.${DATA_KEY}`;
const DATA_API_KEY = '.data-api';
const JQUERY_NO_CONFLICT = window.jQuery.fn[NAME];
const TRANSITION_DURATION = 350;

const Util = (() => { // eslint-disable-line no-shadow
  const TRANSITION_END = 'transitionend';

  const Util = { // eslint-disable-line no-shadow
    TRANSITION_END: 'mmTransitionEnd',

    triggerTransitionEnd(element) {
      window.jQuery(element).trigger(TRANSITION_END);
    },

    supportsTransitionEnd() {
      return Boolean(TRANSITION_END);
    },
  };

  function getSpecialTransitionEndEvent() {
    return {
      bindType: TRANSITION_END,
      delegateType: TRANSITION_END,
      handle(event) {
        if (window.jQuery(event.target).is(this)) {
          return event
            .handleObj
            .handler
            .apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
        return undefined;
      },
    };
  }

  function transitionEndEmulator(duration) {
    let called = false;

    window.jQuery(this).one(Util.TRANSITION_END, () => {
      called = true;
    });

    setTimeout(() => {
      if (!called) {
        Util.triggerTransitionEnd(this);
      }
    }, duration);

    return this;
  }

  function setTransitionEndSupport() {
    window.jQuery.fn.mmEmulateTransitionEnd = transitionEndEmulator; // eslint-disable-line no-param-reassign
    // eslint-disable-next-line no-param-reassign
    window.jQuery.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
  }

  setTransitionEndSupport();

  return Util;
})(jQuery);

const Default = {
  toggle: true,
  preventDefault: true,
  triggerElement: 'a',
  parentTrigger: 'li',
  subMenu: 'ul',
};

const Event = {
  SHOW: `show${EVENT_KEY}`,
  SHOWN: `shown${EVENT_KEY}`,
  HIDE: `hide${EVENT_KEY}`,
  HIDDEN: `hidden${EVENT_KEY}`,
  CLICK_DATA_API: `click${EVENT_KEY}${DATA_API_KEY}`,
};

const ClassName = {
  METIS: 'metismenu',
  ACTIVE: 'mm-active',
  SHOW: 'mm-show',
  COLLAPSE: 'mm-collapse',
  COLLAPSING: 'mm-collapsing',
  COLLAPSED: 'mm-collapsed',
};

class MetisMenu {
  // eslint-disable-line no-shadow
  constructor(element, config) {
    this.element = element;
    this.config = {
      ...Default,
      ...config,
    };
    this.transitioning = null;

    this.init();
  }

  init() {
    const self = this;
    const conf = this.config;
    const el = window.jQuery(this.element);

    el.addClass(ClassName.METIS); // add metismenu class to element

    el.find(`${conf.parentTrigger}.${ClassName.ACTIVE}`)
      .children(conf.triggerElement)
      .attr('aria-expanded', 'true'); // add attribute aria-expanded=true the trigger element

    el.find(`${conf.parentTrigger}.${ClassName.ACTIVE}`)
      .parents(conf.parentTrigger)
      .addClass(ClassName.ACTIVE);

    el.find(`${conf.parentTrigger}.${ClassName.ACTIVE}`)
      .parents(conf.parentTrigger)
      .children(conf.triggerElement)
      .attr('aria-expanded', 'true'); // add attribute aria-expanded=true the triggers of all parents

    el.find(`${conf.parentTrigger}.${ClassName.ACTIVE}`)
      .has(conf.subMenu)
      .children(conf.subMenu)
      .addClass(`${ClassName.COLLAPSE} ${ClassName.SHOW}`);

    el
      .find(conf.parentTrigger)
      .not(`.${ClassName.ACTIVE}`)
      .has(conf.subMenu)
      .children(conf.subMenu)
      .addClass(ClassName.COLLAPSE);

    el
      .find(conf.parentTrigger)
      // .has(conf.subMenu)
      .children(conf.triggerElement)
      .on(Event.CLICK_DATA_API, function (e) { // eslint-disable-line func-names
        const eTar = window.jQuery(this);

        if (eTar.attr('aria-disabled') === 'true') {
          return;
        }

        if (conf.preventDefault && eTar.attr('href') === '#') {
          e.preventDefault();
        }

        const paRent = eTar.parent(conf.parentTrigger);
        const sibLi = paRent.siblings(conf.parentTrigger);
        const sibTrigger = sibLi.children(conf.triggerElement);

        if (paRent.hasClass(ClassName.ACTIVE)) {
          eTar.attr('aria-expanded', 'false');
          self.removeActive(paRent);
        } else {
          eTar.attr('aria-expanded', 'true');
          self.setActive(paRent);
          if (conf.toggle) {
            self.removeActive(sibLi);
            sibTrigger.attr('aria-expanded', 'false');
          }
        }

        if (conf.onTransitionStart) {
          conf.onTransitionStart(e);
        }
      });
  }

  setActive(li) {
    window.jQuery(li).addClass(ClassName.ACTIVE);
    const ul = window.jQuery(li).children(this.config.subMenu);
    if (ul.length > 0 && !ul.hasClass(ClassName.SHOW)) {
      this.show(ul);
    }
    const aTag = window.jQuery(li).children(this.config.triggerElement);
    if (aTag.length > 0 && !aTag.hasClass(ClassName.ACTIVE)) {
      this.setActive(aTag);
    }
  }

  removeActive(li) {
    window.jQuery(li).removeClass(ClassName.ACTIVE);
    const ul = window.jQuery(li).children(`${this.config.subMenu}.${ClassName.SHOW}`);
    if (ul.length > 0) {
      this.hide(ul);
    }
    const aTag = window.jQuery(li).children(this.config.triggerElement);
    if (aTag.length > 0 && aTag.hasClass(ClassName.ACTIVE)) {
      this.removeActive(aTag);
    }
  }

  show(element) {
    if (this.transitioning || window.jQuery(element).hasClass(ClassName.COLLAPSING)) {
      return;
    }
    const elem = window.jQuery(element);

    const startEvent = window.jQuery.Event(Event.SHOW);
    elem.trigger(startEvent);

    if (startEvent.isDefaultPrevented()) {
      return;
    }

    elem.parent(this.config.parentTrigger).addClass(ClassName.ACTIVE);

    if (this.config.toggle) {
      const toggleElem = elem.parent(this.config.parentTrigger).siblings().children(`${this.config.subMenu}.${ClassName.SHOW}`);
      this.hide(toggleElem);
    }

    elem
      .removeClass(ClassName.COLLAPSE)
      .addClass(ClassName.COLLAPSING)
      .height(0);

    this.setTransitioning(true);

    const complete = () => {
      // check if disposed
      if (!this.config || !this.element) {
        return;
      }
      elem
        .removeClass(ClassName.COLLAPSING)
        .addClass(`${ClassName.COLLAPSE} ${ClassName.SHOW}`)
        .height('');

      this.setTransitioning(false);

      elem.trigger(Event.SHOWN);
    };

    elem
      .height(element[0].scrollHeight)
      .one(Util.TRANSITION_END, complete)
      .mmEmulateTransitionEnd(TRANSITION_DURATION);
  }

  hide(element) {
    if (
      this.transitioning || !window.jQuery(element).hasClass(ClassName.SHOW)
    ) {
      return;
    }

    const elem = window.jQuery(element);

    const startEvent = window.jQuery.Event(Event.HIDE);
    elem.trigger(startEvent);

    if (startEvent.isDefaultPrevented()) {
      return;
    }

    elem.parent(this.config.parentTrigger).removeClass(ClassName.ACTIVE);
    // eslint-disable-next-line no-unused-expressions
    elem.height(elem.height())[0].offsetHeight;

    elem
      .addClass(ClassName.COLLAPSING)
      .removeClass(ClassName.COLLAPSE)
      .removeClass(ClassName.SHOW);

    this.setTransitioning(true);

    const complete = () => {
      // check if disposed
      if (!this.config || !this.element) {
        return;
      }
      if (this.transitioning && this.config.onTransitionEnd) {
        this.config.onTransitionEnd();
      }

      this.setTransitioning(false);
      elem.trigger(Event.HIDDEN);

      elem
        .removeClass(ClassName.COLLAPSING)
        .addClass(ClassName.COLLAPSE);
    };

    if (elem.height() === 0 || elem.css('display') === 'none') {
      complete();
    } else {
      elem
        .height(0)
        .one(Util.TRANSITION_END, complete)
        .mmEmulateTransitionEnd(TRANSITION_DURATION);
    }
  }

  setTransitioning(isTransitioning) {
    this.transitioning = isTransitioning;
  }

  dispose() {
    window.jQuery.removeData(this.element, DATA_KEY);

    window.jQuery(this.element)
      .find(this.config.parentTrigger)
      // .has(this.config.subMenu)
      .children(this.config.triggerElement)
      .off(Event.CLICK_DATA_API);

    this.transitioning = null;
    this.config = null;
    this.element = null;
  }

  static jQueryInterface(config) {
    // eslint-disable-next-line func-names
    return this.each(function () {
      const $this = window.jQuery(this);
      let data = $this.data(DATA_KEY);
      const conf = {
        ...Default,
        ...$this.data(),
        ...(typeof config === 'object' && config ? config : {}),
      };

      if (!data) {
        data = new MetisMenu(this, conf);
        $this.data(DATA_KEY, data);
      }

      if (typeof config === 'string') {
        if (data[config] === undefined) {
          throw new Error(`No method named "${config}"`);
        }
        data[config]();
      }
    });
  }
}

export function handleMetisMenu() {
  if (window.jQuery('#menu').length > 0) {
    window.jQuery("#menu").metisMenu();
  }
  window.jQuery('.metismenu > .mm-active ').each(function () {
    if (!window.jQuery(this).children('ul').length > 0) {
      window.jQuery(this).addClass('active-no-child');
    }
  });
}

export function handleNavigation() {
  window.jQuery(".nav-control").on('click', function () {

    window.jQuery('#main-wrapper').toggleClass("menu-toggle");

    window.jQuery(".hamburger").toggleClass("is-active");
  });
}

export function handleCurrentActive() {
  const currentURL = window.location.href;

  var activeElement = Array.from(document.querySelectorAll('ul#menu a')).filter(function (i1) {
    var hrefAsURL = new URL(i1.href)
    if (window.location.pathname === '/') {
      return currentURL === i1.href;
    } else if (i1.href && i1.href !== (window.location.origin + '/')) {
      return window.location.pathname.split('/')[1] == hrefAsURL.pathname.split('/')[1];
    }
    return false;
  })?.[0];

  if (activeElement) {
    activeElement = window.jQuery(activeElement);
    // TODO :: Shitty code :-) Anyways, better than inifinite loop
    activeElement
      .addClass('mm-active')
      .parent()
      .addClass('mm-active')
      .parent()
      .addClass('mm-show')
      .parent()
      .addClass('mm-active');
  }
}

export function handleMiniSidebar() {
  window.jQuery("ul#menu>li").on('click', function () {
    const sidebarStyle = window.jQuery('body').attr('data-sidebar-style');
    if (sidebarStyle === 'mini') {
      window.jQuery(this).find('ul').stop()
    }
  })
}

export function handleMenuPosition() {
  let screenWidth = window.jQuery(window).width();
  if (screenWidth > 1024) {
    window.jQuery(".metismenu  li").unbind().each(function (e) {
      if (window.jQuery('ul', this).length > 0) {
        let elm = window.jQuery('ul:first', this).css('display', 'block');

        let off = elm.offset();
        let l = off.left;
        let w = elm.width();
        elm = window.jQuery('ul:first', this).removeAttr('style');

        let isEntirelyVisible = (l > 0) ? true : false;

        if (window.jQuery('html').hasClass('rtl')) {
          isEntirelyVisible = (l + w <= window.jQuery("body").width());
        }
        if (!isEntirelyVisible) {
          window.jQuery(this).find('ul:first').addClass('left');
        } else {
          window.jQuery(this).find('ul:first').removeClass('left');
        }
      }
    });
  }
}

export function manageResponsiveSidebar() {
  if (!window.jQuery('body')) return;
  const innerWidth = window.jQuery(window).innerWidth();
  const body = window.jQuery("body");
  if (innerWidth < 1024) {
    body.attr("data-layout", "vertical");
    body.attr("data-container", "wide");
  }

  if (innerWidth > 767 && innerWidth < 1024) {
    body.attr("data-sidebar-style", "mini");
  }

  if (innerWidth < 768) {
    body.attr("data-sidebar-style", "overlay");
  }
}

window.jQuery.fn[NAME] = MetisMenu.jQueryInterface; // eslint-disable-line no-param-reassign
window.jQuery.fn[NAME].Constructor = MetisMenu; // eslint-disable-line no-param-reassign
window.jQuery.fn[NAME].noConflict = () => {
  // eslint-disable-line no-param-reassign
  window.jQuery.fn[NAME] = JQUERY_NO_CONFLICT; // eslint-disable-line no-param-reassign
  return MetisMenu.jQueryInterface;
};

// ON RESIZE
window.jQuery(window).on('resize', function () {
  setTimeout(function () {
    manageResponsiveSidebar();
    handleMenuPosition();
  }, 150);
});
